<template>
	<main class="m-public-bg m-index">
		<div class="load" v-if="!showTab"></div>
		<article class="content" v-else>
			<!-- tab -->
			<nav class="tab">
				<button
					class="tab-item"
					v-for="item in data"
					:key="item.id"
					:class="{ active: item.id === currentTeacherId }"
					@click="changeTeacher(item)"
					:aria-label="`選擇老師 ${item.teacher_info?.nickname}`"
				>
					<van-image
						class="avatar"
						:src="item.avatar"
						:alt="`${item.teacher_info?.nickname}老師頭像`"
					/>
					<p class="nickname">{{ item.teacher_info?.nickname }}</p>
				</button>
			</nav>

			<Banner :data="currentTeacher?.teacher_info?.home_background" />
			<!-- 老师信息 -->
			<section class="teacher-info">
				<h1 class="name">{{ currentTeacher.teacher_info.nickname }}</h1>
				<div class="tag-box" v-if="currentTeacher.teacher_info.tags.length > 0">
					<span class="label">專長：</span>
					<ul class="tag">
						<li v-for="(item, index) in currentTeacher.teacher_info.tags" :key="index">
							{{ item }}
						</li>
					</ul>
				</div>
				<p class="desc">{{ currentTeacher.teacher_info.introduce }}</p>
			</section>
			<!-- 代言测试和老师服务 -->
			<van-tabs animated v-model:active="active">
				<van-tab title="推薦測試">
					<div v-show="active === 0">
						<Cs
							:data="csData"
							:cs-event="currentTeacher.csEvent"
							:schannel="currentTeacher.schannel"
						/>
						<van-empty description="暫無數據" v-if="!csData.length" />
					</div>
				</van-tab>
				<van-tab title="老師服務">
					<div v-show="active === 1">
						<TeacherService
							:data="teacherService"
							:teacher-id="currentTeacher.id"
							:teacherInfo="currentTeacher.teacher_info"
							:chat-event="currentTeacher.chatEvent"
						/>
						<van-empty description="暫無數據" v-if="!teacherService.length" />
					</div>
				</van-tab>
			</van-tabs>
			<!-- 最新文章视频 -->
			<TeacherSquare :data="teacherSquare" />
			<!-- 活动内容 -->
			<Activity :data="activityData" v-if="activityData.length > 0" />
			<!-- 老师媒体 -->
			<TeacherMedia :data="mediaData" />
			<section class="more-teacher">
				<h2 class="title">更多老師推薦</h2>
				<div class="rank">
					<TeacherRank class="teacher-rank" :data="dongfangRank" :type="'dongfang'" />
					<TeacherRank :data="tarotRank" :type="'tarot'" />
				</div>
			</section>
		</article>
	</main>
</template>

<script setup>
import {
	getRankingList,
	getResourse,
	getTeacherService,
	getTeacherSquare,
	getUserDetail,
} from "~/api/api";
import { removeDomain } from "~/utils/common";
import { computed, ref, watchEffect } from "vue";
import { logEvent } from "~/utils/firebase";

// 组件
import Activity from "./components/activity/index.vue";
import Cs from "./components/cs/index.vue";
import TeacherMedia from "./components/teacher-media/index.vue";
import TeacherRank from "./components/teacher-rank/index.vue";
import TeacherService from "./components/teacher-service/index.vue";
import TeacherSquare from "./components/teacher-square/index.vue";
import Banner from "./components/van-banner/index.vue";

// 图片
import avatar1 from "./images/avatar1.png";
import avatar2 from "./images/avatar2.png";
import avatar3 from "./images/avatar3.png";
import avatar4 from "./images/avatar4.png";

// 客户端环境执行
onMounted(() => {
	if (import.meta.client) {
		logEvent("site_master_uv");
	}
});

const active = ref(0);

const data = ref([
	{
		// 振鸿
		id: "164197918000000150",
		avatar: avatar4,
		csClass: 110,
		activityClass: 111,
		mediaClass: 112,
		teacher_info: {},
		tabEvent: "site_master_zhenhong_click",
		csEvent: "site_master_zhenhong_reccalc_click",
		chatEvent: "site_master_zhenhong_ask_click",
		schannel: "master-zhenhong-m",
	},
	{
		// 烽燧
		id: "64435",
		avatar: avatar2,
		csClass: 113,
		activityClass: 114,
		mediaClass: 115,
		teacher_info: {},
		tabEvent: "site_master_fengsui_click",
		csEvent: "site_master_fengsui_reccalc_click",
		chatEvent: "site_master_fengsui_ask_click",
		schannel: "master-dashixiong-m",
	},
	{
		// 法名
		id: "162156213800000090",
		avatar: avatar3,
		csClass: 107,
		activityClass: 108,
		mediaClass: 109,
		teacher_info: {},
		tabEvent: "site_master_faming_click",
		csEvent: "site_master_faming_reccalc_click",
		chatEvent: "site_master_faming_ask_click",
		schannel: "master-faming-m",
	},
	{
		// 慕云
		id: "157425565300200060",
		avatar: avatar1,
		csClass: 104,
		activityClass: 105,
		mediaClass: 106,
		teacher_info: {},
		tabEvent: "site_master_muyun_click",
		csEvent: "site_master_muyun_reccalc_click",
		chatEvent: "site_master_muyun_ask_click",
		schannel: "master-muyun-m",
	},
	// {
	//   // 麦玲玲
	//   id: '7963',
	//   csClass: 104,
	//   activityClass: 105,
	//   mediaClass: 106,
	//   teacher_info: {},
	// },
]);

const promises = data.value.map(item => {
	return new Promise(async resolve => {
		await getUserDetail({
			uid: item.id,
		}).then(res => {
			item.teacher_info = res.data;
		});
		resolve();
	});
});

const showTab = ref(false);
Promise.all(promises).then(() => {
	showTab.value = true;
});

const currentTeacher = computed(() => {
	const res = data.value.find(item => currentTeacherId.value === item.id);
	logEvent(res.tabEvent);
	return res;
});
const currentTeacherId = ref(data.value[0].id);
const loading = ref(false);
const csData = ref([]);
const activityData = ref([]);
const mediaData = ref([]);
const teacherService = ref([]);
const teacherSquare = ref({
	text: [],
	video: [],
});
const getTeacherData = () => {
	loading.value = true;
	// 获取代言测试
	getResourse({
		class: currentTeacher.value.csClass,
	}).then(res => {
		csData.value = res.data.map(v => {
			return {
				...v,
				jump_url: removeDomain(v.actioncontent.global_type),
			};
		});
		loading.value = false;
	});
	// 获取活动
	getResourse({
		class: currentTeacher.value.activityClass,
	}).then(res => {
		activityData.value = res.data.map(v => {
			return {
				...v,
				jump_url: removeDomain(v.actioncontent.global_type),
			};
		});
	});
	// 获取媒体
	getResourse({
		class: currentTeacher.value.mediaClass,
	}).then(res => {
		mediaData.value = res.data.map(v => {
			return {
				...v,
				jump_url: v.actioncontent.global_type,
			};
		});
	});
	// 获取老师服务
	getTeacherService({
		uid: currentTeacherId.value,
		high_service_type: 1,
	}).then(res => {
		teacherService.value = res.data[0].list;
	});
	// 获取老师廣場
	// getTeacherSquare({
	//   teacher_uid: currentTeacherId.value,
	//   type: 2,
	// }).then((res) => {
	//   teacherSquare.value.text = res.data.list.map((item) => {
	//     return {
	//       ...item,
	//       media_url: JSON.parse(item.media_url),
	//     };
	//   });
	// });
	getTeacherSquare({
		teacher_uid: currentTeacherId.value,
		type: 1,
	}).then(res => {
		teacherSquare.value.video = res.data.list.map(item => {
			return {
				...item,
				media_url: JSON.parse(item.media_url),
			};
		});
	});
};
getTeacherData();

const changeTeacher = item => {
	currentTeacherId.value = item.id;
	getTeacherData();
};

const dongfangRank = ref([]);
const tarotRank = ref([]);
getRankingList().then(res => {
	dongfangRank.value = res.data[0].data;
	tarotRank.value = res.data[1].data;
});
</script>

<style lang="scss" scoped>
.m-index {
	width: 100%;
	padding-bottom: 24px;
	min-height: 100vh;
	font-family: PingFang SC;
	overflow-x: hidden;

	.load {
		height: 100vh;
	}

	.tab {
		padding: 12px 32px;
		display: flex;
		justify-content: space-around;
		gap: 24px;
		flex-wrap: nowrap;
		font-family: PingFang SC;
		user-select: none;
		overflow-x: scroll;

		.tab-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 170px;
			background: none;
			border: none;
			cursor: pointer;
			padding: 0;

			.avatar {
				width: 128px;
				height: 128px;
				border-radius: 50%;
				object-fit: cover;
				overflow: hidden;
			}

			.nickname {
				width: 110px;
				margin-top: 8px;
				font-family:
					PingFang SC,
					PingFang SC;
				font-size: 24px;
				color: #333333;
				line-height: 40px;
				text-align: center;
			}
		}
	}

	.teacher-info {
		margin-top: 24px;
		padding: 0 32px;

		.name {
			font-weight: 600;
			font-size: 44px;
			color: #333333;
			line-height: 66px;
		}

		.tag-box {
			margin: 22px 0;
			display: flex;
			align-items: center;

			.label {
				margin-right: 6px;
				white-space: nowrap;
				font-weight: 500;
				font-size: 28px;
				color: #333333;
			}

			.tag {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				overflow: hidden;
				list-style: none;
				padding: 0;
				margin: 0;

				li {
					margin-right: 16px;
					display: inline-block;
					padding: 4px 12px;
					font-weight: 500;
					font-size: 28px;
					color: #884a12;
					background: #f5e7cb;
					border-radius: 8px;
				}
			}
		}

		.desc {
			width: 686px;
			font-weight: 400;
			font-size: 28px;
			color: #666666;
			line-height: 44px;
		}
	}

	:deep(.van-tabs) {
		margin-top: 32px;
		.van-tabs__nav {
			background: transparent;
		}

		.van-tabs__line {
			background-color: #d4975e;
		}

		.van-tab__text {
			font-size: 32px;
			overflow: visible;
		}
	}
}

.more-teacher {
	margin-top: 64px;

	.title {
		padding: 0 32px;
		font-family: PingFang SC;
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		line-height: 60px;
	}

	.rank {
		padding: 0 32px;
		margin-top: 32px;
		width: 100%;
		display: flex;
		overflow-x: scroll;

		.teacher-rank {
			margin-right: 16px;
		}
	}
}
</style>
